import { make } from 'vuex-pathify'
import repository from '../../apis/repository'

const state = { settings: {} }

const getters = make.getters(state)
const mutations = make.mutations(state)

const actions = {
	async get({ commit }) {
		const { data } = await repository.settings.get()
		commit('SET_SETTINGS', data.settings)

		return data.settings
	},
	update(context, payload) {
		return repository.settings.update(payload)
	},
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
}
